import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { insPacingPlansStateId } from "common/constants";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { language } from "language/default";
import { setMessagesDialog } from "store/messages-dialog";
export const InsDeletePacingPlanAction = (props) => {
    const selectedRows = useSelector((state) => state.grids.state[insPacingPlansStateId]?.selectedRows, isEqual) ?? [];
    const dispatch = useDispatch();
    const handlePacingPlanDeletion = () => {
        dispatch(setMessagesDialog({ functionName: MessagesDialogFunctionName.DeletePacingPlan,
            hasCustomFooter: true,
            isPrimaryButtonDelete: true,
            messages: [{ message: language.en.modal.pacingPlanCreation.pacingPlanDeletion.deletePacingPlanAlertFirstLine }],
            title: language.en.modal.pacingPlanCreation.pacingPlanDeletion.deletePacingPlanAlertHeader,
            type: "alert-with-options" }));
    };
    return React.createElement(React.Fragment, null,
        React.createElement(AuxButton, { size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, isDisabled: selectedRows.length === 0 || props.isDisabled, onClick: handlePacingPlanDeletion, label: language.en.modal.pacingPlanCreation.pacingPlanDeletion.deletePacingPlan }));
};
